import * as z from 'zod'

import { SupportedMarketKey } from '@nxt-insurance/constants'

import { getLocationSchema } from '@flows/configs/common/steps/location'
import { getLocationValidatorHook } from '@flows/configs/shared/validatorHooks'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LiabilityV1GetsafeDe } from '@flows/insurance/schemas'

const liability_address = (params: StepConfigParams) =>
  ({
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.location.title',
        },
      },
      {
        type: 'addressAutocomplete',
        name: 'address_autocomplete',
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.address_autocomplete.label',
        },
      },
    ],
    schema: getLocationSchema(params.market ?? SupportedMarketKey.De).merge(
      z.object({
        zip_code: BaseSchema_LiabilityV1GetsafeDe.shape.zip_code,
      })
    ),
    onSubmit: getLocationValidatorHook(params),
    nextStep: 'underwriting_validation',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default liability_address
